import { useQuery } from '@tanstack/vue-query'

import type { TransitDataset } from '@/types'

const transitDatasetUrl = `${import.meta.env.BASE_URL}data/routes.json?v=${__TRANSIT_DATASET_DIGEST__}`
const transitDatasetQueryKey = ['transit-dataset', __TRANSIT_DATASET_DIGEST__] as const

async function fetchTransitDataset(signal: AbortSignal) {
  const response = await fetch(transitDatasetUrl, { signal })

  if (!response.ok) {
    throw new Error(`Data request failed (${response.status})`)
  }

  return (await response.json()) as TransitDataset
}

export function useTransitDataQuery() {
  return useQuery({
    queryKey: transitDatasetQueryKey,
    queryFn: ({ signal }) => fetchTransitDataset(signal),
    staleTime: Number.POSITIVE_INFINITY,
    gcTime: Number.POSITIVE_INFINITY,
  })
}
